module.exports = __webpack_public_path__ + "img/stock5.a5c92d28.png";